<template>
    <div class="relative bg-white px-4 sm:px-8 py-6 sm:py-10 rounded-sm shadow border border-slate-300">

        <perforation-edge position="top" />

        <div v-for="item in invoice.lines?.data || []" :key="item.id" class="mb-3 flex justify-between place-items-baseline gap-6 sm:gap-1 text-sm sm:text-base">
            <div class="text-slate-500 sm:text-slate-900">{{ item.description }}</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(item.amount) }}</div>
        </div>

        <div class="sm:hidden mt-6 border-b border-y-0 border-slate-300 border-dashed"></div>

        <div v-if="invoice.subtotal !== invoice.total" class="mt-6 flex justify-between place-items-baseline gap-6 sm:gap-1 font-bold">
            <div>Subtotal</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(invoice.subtotal) }}</div>
        </div>

        <div v-if="invoice.tax" class="mt-3 flex justify-between place-items-baseline gap-6 sm:gap-1 text-sm sm:text-base">
            <div class="text-slate-500 sm:text-slate-900">Tax</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(invoice.tax) }}</div>
        </div>

        <div v-for="discount in invoice.total_discount_amounts || []" :key="discount.amount" class="mt-3 flex justify-between place-items-baseline gap-6 sm:gap-1 text-sm sm:text-base">
            <div class="text-slate-500 sm:text-slate-900">Discount</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>-{{ currencyCents(discount.amount) }}</div>
        </div>

        <div class="mt-6 flex justify-between place-items-baseline gap-6 sm:gap-1 font-bold">
            <div>Total</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(invoice.total) }}</div>
        </div>

        <div class="sm:hidden mt-6 border-b border-y-0 border-slate-300 border-dashed"></div>

        <div class="mt-6 flex justify-between sm:justify-normal gap-2 items-center text-xs text-slate-500">
            <div>Next bill:</div>
            <vx-badge color="amber" size="xs">
                {{ date(invoice.period_end * 1000) }}
            </vx-badge>
        </div>

        <perforation-edge position="bottom" />

    </div>
</template>

<script setup>
import { VxBadge } from '@voxie/frontend-components';
import PerforationEdge from '~/components/general/PerforationEdge.vue';
import { currencyCents, date } from '~/utils/helpers';

defineProps({
    // Stripe invoice object
    invoice: {
        type: Object
    },
});
</script>
